export default "__VITE_ASSET__CmIgdr2E__"